export default __webpack_public_path__ + "static/screen_chart_5-58b7bbed9a73fccfb10060e722670de9.png";